import { DateTime } from "luxon";

export const BOOKING_LINK = "https://meetings.hubspot.com/dominic-bennett/pricing-page";
export const ANNUAL_UPGRADE_LINK =
  "https://app.hubspot.com/payments/DmQRpCZNXwPX6D?referrer=PAYMENT_LINK";
export const MONTHLY_UPGRADE_LINK =
  "https://app.hubspot.com/payments/DZj4JtF4ZF?referrer=PAYMENT_LINK";

/**
 * @param annual is a boolean indicating whether the upgrade is for annual or monthly billing
 * @param email is an optional email address to include in the upgrade link. Providing this auto-populates the email field in the upgrade form
 * @returns a string representing the upgrade link
 */
export const upgradeLink = (annual: boolean, email?: string) => {
  if (!isWorkingHours()) {
    return BOOKING_LINK;
  }

  if (annual) {
    return `${ANNUAL_UPGRADE_LINK}${email ? `&email=${email}` : ""}`;
  } else {
    return `${MONTHLY_UPGRADE_LINK}${email ? `&email=${email}` : ""}`;
  }
};

/**
 *
 * @returns boolean indicating whether it's currently working hours in London (8am-6pm, Monday to Friday)
 */
export const isWorkingHours = () => {
  const ukTime = DateTime.now().setZone("Europe/London");

  const isWeekday = ukTime.weekday >= 1 && ukTime.weekday <= 5; // Monday to Friday
  const isBusinessHours = ukTime.hour >= 8 && ukTime.hour < 18; // 8am to 6pm

  return isWeekday && isBusinessHours;
};
